// extracted by mini-css-extract-plugin
export default {"scroll_btn":"ScrollUpButton_scroll_btn__ur3gG","scroll_link":"ScrollUpButton_scroll_link__-xn3J"};